import React, { useState } from "react";
import "../css/SaffronHabitat.css";
import { FaFileContract, FaSearch, FaPlus } from "react-icons/fa";
/*
  SaffronHabitat.jsx (floating buttons removed)
  All classes use sh- prefix to avoid collisions.
*/

const listings = [
  {
  image: require("../assets/pgimagesnew3/3.jpeg"), // change to your image path
  title: "Malad – Ajanta CHS",
  tags: ["Featured", "Best Deal"],
  desc:
    "Girls’ PG accommodation at Ajanta CHS, Malad East. Managed by No Brokerage Paying Guest with secure premises, furnished rooms, WiFi, and daily housekeeping.",
  bedrooms: 3,
  bathrooms: 3,
  area: "950 sq ft",
},
  {
    image: require("../assets/pgimages/WhatsApp Image 2025-07-08 at 2.45.15 PM.jpeg"),
    title: "Malad, Goregoan and Kandivali – Deluxe Room",
    tags: ["Featured", "Best Deal"],
    desc:
      "No Brokerage Paying Guest brings spacious PG rooms in Malad, Goregoan and Kandivali. Ideal for students and working professionals with easy metro access.",
    bedrooms: 3,
    bathrooms: 3,
    area: "940 sq ft",
  },
    {
    image: require("../assets/pgimages/WhatsApp Image 2025-07-08 at 2.41.14 PM.jpeg"),
    title: "Malad, Goregoan and Kandivali – Executive Room",
    tags: ["Featured", "Best Deal"],
    desc:
      "Exclusive PG accommodation in Malad, Goregoan and Kandivali managed by No Brokerage Paying Guest. Fully furnished with AC, geyser, WiFi, and 24-hour water supply.",
    bedrooms: 3,
    bathrooms: 3,
    area: "925 sq ft",
  },
  {
    image: require("../assets/pgimagesnew2/IMG-20250923-WA0018.jpg"),
    title: "Malad, Goregoan and Kandivali – Elite Room",
    tags: ["Featured", "Best Deal"],
    desc:
      "No Brokerage Paying Guest offers premium girls’ PG at Pooja Building, Near Pushpa Park, Malad, Goregoan and Kandivali. Safe, secure, and fully maintained for modern living.",
    bedrooms: 3,
    bathrooms: 3,
    area: "920 sq ft",
  },
  {
    image: require("../assets/pgimagesnew2/IMG-20250923-WA0024.jpg"),
    title: "Malad, Goregoan and Kandivali – Standard Room",
    tags: ["Featured", "Best Deal"],
    desc:
      "Girls’ PG accommodation by No Brokerage Paying Guest in Malad, Goregoan and Kandivali. Fully furnished flats with housekeeping and 24x7 security.",
    bedrooms: 3,
    bathrooms: 3,
    area: "930 sq ft",
  },
  {
    image: require("../assets/pgimagesnew2/IMG-20250923-WA0021.jpg"),
    title: "Malad, Goregoan and Kandivali – Premium Room",
    tags: ["Featured", "Best Deal"],
    desc:
      "Comfortable and hygienic PG rooms near Near Pushpa Park, Malad, Goregoan and Kandivali. Managed by No Brokerage Paying Guest with WiFi and daily cleaning.",
    bedrooms: 3,
    bathrooms: 3,
    area: "910 sq ft",
  },

  {
    image: require("../assets/pgimagesnew2/IMG-20250923-WA0014.jpg"),
    title: "Malad, Goregoan and Kandivali – Comfort Room",
    tags: ["Featured", "Best Deal"],
    desc:
      "Girls’ PG rooms at Pooja Building, Near Pushpa Park, Malad, Goregoan and Kandivali – secure environment, Aqua Guard, and flexible lease options by No Brokerage Paying Guest.",
    bedrooms: 3,
    bathrooms: 3,
    area: "915 sq ft",
  },

];


export default function SaffronHabitat() {
  const amenities = [
    { icon: "bed", label: "Bed" },
    { icon: "cupboard", label: "Cupboard" },
    { icon: "ac", label: "Air Conditioner" },
    { icon: "fridge", label: "Fridge" },
    { icon: "washing", label: "Washing Machine" },
    { icon: "geyser", label: "Geyser" },
    { icon: "water", label: "Aqua Guard" },
    { icon: "stove", label: "Gas Stove" },
    { icon: "supply", label: "24 hours Water" },
    { icon: "microwave", label: "Microwave Oven" },
    { icon: "wifi", label: "WiFi" },
    { icon: "cleaning", label: "Housekeeping" },
  ];
    // SVG map
  const renderIcon = (key) => {
    switch (key) {
      case "bed":
        return <path d="M2 12h20M4 12V6a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v6" />;
      case "cupboard":
        return (
          <>
            <rect x="4" y="3" width="16" height="18" rx="2" ry="2"></rect>
            <line x1="12" y1="3" x2="12" y2="21"></line>
            <circle cx="9" cy="12" r="1"></circle>
            <circle cx="15" cy="12" r="1"></circle>
          </>
        );
      case "ac":
        return (
          <>
            <rect x="3" y="4" width="18" height="8" rx="2"></rect>
            <line x1="7" y1="20" x2="17" y2="20"></line>
            <line x1="12" y1="12" x2="12" y2="20"></line>
          </>
        );
      case "fridge":
        return (
          <>
            <rect x="6" y="2" width="12" height="20" rx="2"></rect>
            <line x1="6" y1="10" x2="18" y2="10"></line>
            <line x1="10" y1="6" x2="10" y2="6"></line>
            <line x1="10" y1="14" x2="10" y2="14"></line>
          </>
        );
      case "washing":
        return (
          <>
            <rect x="4" y="2" width="16" height="20" rx="2"></rect>
            <circle cx="12" cy="13" r="5"></circle>
            <circle cx="12" cy="6" r="1"></circle>
          </>
        );
      case "geyser":
        return (
          <>
            <rect x="8" y="2" width="8" height="20" rx="4"></rect>
            <line x1="12" y1="6" x2="12" y2="6"></line>
            <line x1="12" y1="10" x2="12" y2="10"></line>
          </>
        );
      case "water":
        return (
          <>
            <path d="M12 2.69l5.66 5.66a8 8 0 1 1-11.31 0z"></path>
          </>
        );
      case "stove":
        return (
          <>
            <rect x="3" y="6" width="18" height="12" rx="2"></rect>
            <circle cx="9" cy="12" r="1"></circle>
            <circle cx="15" cy="12" r="1"></circle>
          </>
        );
      case "supply":
        return (
          <>
            <path d="M12 2a7 7 0 0 0 0 14h0a7 7 0 0 0 0-14z"></path>
          </>
        );
      case "microwave":
        return (
          <>
            <rect x="3" y="6" width="18" height="12" rx="2"></rect>
            <line x1="7" y1="12" x2="7" y2="12"></line>
            <line x1="17" y1="12" x2="17" y2="12"></line>
          </>
        );
      case "wifi":
        return (
          <>
            <path d="M5 12.55a11 11 0 0 1 14 0"></path>
            <path d="M8.5 16.04a5 5 0 0 1 7 0"></path>
            <line x1="12" y1="20" x2="12" y2="20"></line>
          </>
        );
      case "cleaning":
        return (
          <>
            <path d="M3 20h18"></path>
            <path d="M10 12v8"></path>
            <path d="M14 12v8"></path>
            <path d="M6 8h12l-2 4H8z"></path>
          </>
        );
      default:
        return null;
    }
  };

  const [isBookingOpen, setIsBookingOpen] = useState(false);
  const [bookingTitle, setBookingTitle] = useState("");
  const [formData, setFormData] = useState({ name: "", email: "", contact: "" });
  const [lightboxSrc, setLightboxSrc] = useState(null);

  const openBookingModal = (title) => {
    setBookingTitle(title);
    setIsBookingOpen(true);
  };

  const closeBookingModal = () => {
    setIsBookingOpen(false);
    setFormData({ name: "", email: "", contact: "" });
  };

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setFormData((p) => ({ ...p, [name]: value }));
  };

  const handleBookingSubmit = (e) => {
    e.preventDefault();
    const { name, email, contact } = formData;
    if (!name || !email || !contact) {
      alert("Please fill in all fields before submitting.");
      return;
    }
    const message = `Hello, I am interested in booking accommodation for *${bookingTitle}*.\n\nName: ${name}\nEmail: ${email}\nContact: ${contact}`;
    const whatsappURL = `https://wa.me/918879779777?text=${encodeURIComponent(message)}`;
    window.open(whatsappURL, "_blank");
    closeBookingModal();
  };

  const handleCTAClick = () => {
    window.open("https://wa.me/918879779777?text=Hi%20Saffron%20Habitat!", "_blank");
  };

  const handlePhoneClick = () => {
    window.location.href = "tel:+918879779777";
  };

  return (
    <div className="sh-page">
      {/* HERO */}
      <section className="sh-hero">
        <div
          className="sh-hero-bg"
          style={{
            backgroundImage: `url(${require("../assets/hotel5.jpg")})`,
          }}
          role="img"
          aria-hidden="true"
        />
        <div className="sh-hero-overlay" />
        <div className="sh-hero-inner">
          <h1 className="sh-hero-title">Saffron Habitat</h1>
          <p className="sh-hero-sub">Your Trusted Partner for Girls' PG Stays</p>
          <div className="sh-hero-actions">
  <a href="/contact" className="sh-btn-primary">
    Contact Us
  </a>
  <button className="sh-btn-outline" onClick={handlePhoneClick}>
    Call Now
  </button>
</div>

        </div>
      </section>

      {/* FEATURES */}
      <div className="sh-features-grid">

  <div className="sh-feature-card">
    <div className="sh-feature-title">24/7 Security</div>
    <div className="sh-feature-desc">Surveillance & on-site staff</div>
  </div>

  <div className="sh-feature-card">
    <div className="sh-feature-title">Wi-Fi & Utilities</div>
    <div className="sh-feature-desc">All major utilities included</div>
  </div>

  <div className="sh-feature-card">
    <div className="sh-feature-title">Housekeeping</div>
    <div className="sh-feature-desc">Everyday Cleaning</div>
  </div>

  <div className="sh-feature-card">
    <div className="sh-feature-title">Flexible Lease</div>
    <div className="sh-feature-desc">Short & long term</div>
  </div>

</div>
<br/>
      {/* LISTINGS */}
      <section className="sh-listings">
        <h3 className="sh-listings-title">Available Rooms</h3>
        <p className="sh-listings-sub">Choose from our curated rooms — updated frequently.</p>

        <div className="sh-listings-grid">
          {listings.map((item, idx) => (
            <article key={idx} className="sh-card">
              <div
                className="sh-media"
                role="button"
                tabIndex={0}
                onClick={() => setLightboxSrc(item.image)}
                onKeyDown={(e) => e.key === "Enter" && setLightboxSrc(item.image)}
              >
                <img src={item.image} alt={item.title} className="sh-media-img" />
                <div className="sh-tags">
                  {item.tags.map((t) => (
                    <span key={t} className={`sh-tag sh-tag-${t.toLowerCase().replace(/\s+/g, "-")}`}>
                      {t}
                    </span>
                  ))}
                </div>
              </div>

              <div className="sh-body">
                <h4 className="sh-title">{item.title}</h4>
                <p className="sh-desc">{item.desc}</p>

                <div className="sh-meta">
                  <div>
                    <strong>Bedrooms</strong>
                    <br />
                    {item.bedrooms}
                  </div>
                  <div>
                    <strong>Bathrooms</strong>
                    <br />
                    {item.bathrooms}
                  </div>
                  <div>
                    <strong>Area</strong>
                    <br />
                    {item.area}
                  </div>
                </div>

                <div className="sh-footer">
                  <button className="sh-book-btn" onClick={() => openBookingModal(item.title)}>
                    Book Now
                  </button>
                </div>
              </div>
            </article>
          ))}
        </div>
      </section>
    <section className="sh-amenities-section" aria-labelledby="sh-amenities-title">
      <div className="sh-amenities-inner">
        <h3 id="sh-amenities-title" className="sh-amenities-heading">AMENITIES</h3>

        <ul className="sh-amenity-grid" role="list">
          {amenities.map((a) => (
            <li key={a.label} className="sh-amenity-item" role="listitem">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="sh-amenity-icon-svg"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                {renderIcon(a.icon)}
              </svg>
              <span className="sh-amenity-label">{a.label}</span>
            </li>
          ))}
        </ul>

        <div className="sh-amenities-note">
          <div className="sh-included">
            ___________________________________<br />
            All Included<br />
            ___________________________________
          </div>
          <div className="sh-agreement">
  <span className="sh-agreement-left">
    <FaFileContract className="sh-icon" />
    Agreement
  </span>

  <span className="sh-agreement-plus">
    <FaPlus />
  </span>

  <span className="sh-agreement-right">
    <FaSearch className="sh-icon" />
    Police Verification <small className="sh-extra">Extra</small>
  </span>
</div>
        </div>
      </div>
    </section>

      {/* LIGHTBOX */}
      {lightboxSrc && (
        <div className="sh-lightbox" onClick={() => setLightboxSrc(null)}>
          <div className="sh-lightbox-inner" onClick={(e) => e.stopPropagation()}>
            <button className="sh-lb-close" onClick={() => setLightboxSrc(null)} aria-label="Close">
              ×
            </button>
            <img src={lightboxSrc} alt="Preview" />
          </div>
        </div>
      )}

      {/* BOOKING MODAL */}
      {isBookingOpen && (
        <div className="sh-modal" onClick={closeBookingModal}>
          <div className="sh-modal-inner" onClick={(e) => e.stopPropagation()}>
            <button className="sh-modal-close" onClick={closeBookingModal} aria-label="Close booking form">
              ×
            </button>
            <h3 className="sh-modal-title">Book — {bookingTitle}</h3>
            <form className="sh-booking-form" onSubmit={handleBookingSubmit}>
              <label className="sh-form-label">
                <span>Name</span>
                <input name="name" value={formData.name} onChange={handleFormChange} required />
              </label>
              <label className="sh-form-label">
                <span>Email</span>
                <input name="email" type="email" value={formData.email} onChange={handleFormChange} required />
              </label>
              <label className="sh-form-label">
                <span>Contact</span>
                <input name="contact" type="tel" value={formData.contact} onChange={handleFormChange} required />
              </label>

              <div className="sh-form-actions">
                <button type="submit" className="sh-btn-primary sh-modal-submit">
                  Submit
                </button>
                <button type="button" className="sh-btn-ghost" onClick={closeBookingModal}>
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
